import React from "react";
import { useTitle } from "../app/utils";

const TermsOfUse: React.FC = () => {
  useTitle("Termos de Uso do Rebalancear");
  return (
    <div className="flex flex-col p-7 lg:py-24 lg:px-96 text-base lg:text-lg text-neutral-300">
      <div className="text-lg lg:text-3xl font-semibold text-neutral-100">
        Termos de Uso
      </div>

      <div className="pt-4 lg:pt-8 text-base lg:text-lg font-semibold text-neutral-100">
        1. Aceitação dos Termos
      </div>
      <div className="w-full self-center h-1 border-b my-1 lg:mt-5 lg:mb-0 border-neutral-100 [mask-image:linear-gradient(to_right,transparent_0,black_70px,black_calc(100%-70px),transparent_100%)]"></div>
      <div className="p-2 lg:p-0">
        <div className="mt-1 lg:mt-4">Ao acessar e utilizar este site, você concorda em cumprir e ficar vinculado aos Termos de Uso estabelecidos neste documento.</div>
        <div className="mt-2 lg:mt-4">Se você não concorda com estes termos, por favor, não utilize nosso site.</div>
      </div>

      <div className="pt-4 lg:pt-8 text-base lg:text-lg font-semibold text-neutral-100">
        2. Uso do Site
      </div>
      <div className="w-full self-center h-1 border-b my-1 lg:mt-5 lg:mb-0 border-neutral-100 [mask-image:linear-gradient(to_right,transparent_0,black_70px,black_calc(100%-70px),transparent_100%)]"></div>
      <div className="p-2 lg:p-0">
        <div className="mt-1 lg:mt-4">Este site é destinado para uso pessoal e não comercial.</div>
        <div className="mt-2 lg:mt-4">Você concorda em utilizar o site de maneira que não cause danos, interrupções ou interferências no funcionamento do mesmo.</div>
      </div>

      <div className="pt-4 lg:pt-8 text-base lg:text-lg font-semibold text-neutral-100">
        3. Propriedade Intelectual
      </div>
      <div className="w-full self-center h-1 border-b my-1 lg:mt-5 lg:mb-0 border-neutral-100 [mask-image:linear-gradient(to_right,transparent_0,black_70px,black_calc(100%-70px),transparent_100%)]"></div>
      <div className="p-2 lg:p-0">
        <div className="mt-1 lg:mt-4">Todos os conteúdos, incluindo códigos-fonte, textos, gráficos, logotipos e imagens, são de propriedade exclusiva da Rebalancear e estão protegidos por leis de direitos autorais.</div>
        <div className="mt-2 lg:mt-4">É proibida a reprodução, distribuição ou modificação sem a permissão expressa da Rebalancear.</div>
      </div>

      <div className="pt-4 lg:pt-8 text-base lg:text-lg font-semibold text-neutral-100">
        4. Links Externos
      </div>
      <div className="w-full self-center h-1 border-b my-1 lg:mt-5 lg:mb-0 border-neutral-100 [mask-image:linear-gradient(to_right,transparent_0,black_70px,black_calc(100%-70px),transparent_100%)]"></div>
      <div className="p-2 lg:p-0">
        <div className="mt-1 lg:mt-4">Nosso site pode conter links para sites de terceiros. Não temos controle sobre o conteúdo desses sites e não nos responsabilizamos por qualquer informação ou serviço fornecido por eles.</div>
      </div>

      <div className="pt-4 lg:pt-8 text-base lg:text-lg font-semibold text-neutral-100">
        5. Limitação de Responsabilidade
      </div>
      <div className="w-full self-center h-1 border-b my-1 lg:mt-5 lg:mb-0 border-neutral-100 [mask-image:linear-gradient(to_right,transparent_0,black_70px,black_calc(100%-70px),transparent_100%)]"></div>
      <div className="p-2 lg:p-0">
        <div className="mt-1 lg:mt-4">O uso deste site é por sua conta e risco. A Rebalancear não será responsável por quaisquer danos diretos, indiretos, incidentais, consequenciais ou especiais decorrentes do uso ou incapacidade de uso do site.</div>
      </div>

      <div className="pt-4 lg:pt-8 text-base lg:text-lg font-semibold text-neutral-100">
        6. Exclusão de Garantias
      </div>
      <div className="w-full self-center h-1 border-b my-1 lg:mt-5 lg:mb-0 border-neutral-100 [mask-image:linear-gradient(to_right,transparent_0,black_70px,black_calc(100%-70px),transparent_100%)]"></div>
      <div className="p-2 lg:p-0">
        <div className="mt-1 lg:mt-4">Este site é fornecido "como está" e "conforme disponível". A Rebalancear não oferece garantias de qualquer tipo, expressas ou implícitas, sobre o funcionamento do site ou a precisão das informações nele contidas.</div>
      </div>

      <div className="pt-4 lg:pt-8 text-base lg:text-lg font-semibold text-neutral-100">
        7. Privacidade e Proteção de Dados
      </div>
      <div className="w-full self-center h-1 border-b my-1 lg:mt-5 lg:mb-0 border-neutral-100 [mask-image:linear-gradient(to_right,transparent_0,black_70px,black_calc(100%-70px),transparent_100%)]"></div>
      <div className="p-2 lg:p-0">
        <div className="mt-1 lg:mt-4">Conforme a LGPD, coletamos e tratamos dados pessoais seguindo os princípios de finalidade, adequação, necessidade e segurança.</div>
      </div>

      <div className="pt-4 lg:pt-8 text-base lg:text-lg font-semibold text-neutral-100">
        8. Lei Aplicável
      </div>
      <div className="w-full self-center h-1 border-b my-1 lg:mt-5 lg:mb-0 border-neutral-100 [mask-image:linear-gradient(to_right,transparent_0,black_70px,black_calc(100%-70px),transparent_100%)]"></div>
      <div className="p-2 lg:p-0">
        <div className="mt-1 lg:mt-4">Estes Termos de Uso são regidos pelas leis do Brasil. Qualquer disputa decorrente destes termos será resolvida exclusivamente nos tribunais competentes de São Paulo, Brasil.</div>
      </div>

      <div className="pt-4 lg:pt-8 text-base lg:text-lg font-semibold text-neutral-100">
        9. Alterações nos Termos de Uso
      </div>
      <div className="w-full self-center h-1 border-b my-1 lg:mt-5 lg:mb-0 border-neutral-100 [mask-image:linear-gradient(to_right,transparent_0,black_70px,black_calc(100%-70px),transparent_100%)]"></div>
      <div className="p-2 lg:p-0">
        <div className="mt-1 lg:mt-4">Reservamo-nos o direito de modificar estes Termos de Uso a qualquer momento, sem aviso prévio.</div>
        <div className="mt-2 lg:mt-4">Recomendamos que você reveja esta página periodicamente para se manter informado sobre quaisquer alterações.</div>
      </div>

      <div className="min-h-10 lg:min-h-24" />

    </div >
  )
}

export default TermsOfUse;